import { useQuery } from '@tanstack/react-query';
import { api, unwrap, type Schemas } from './client';

export type SystemInfo = Schemas['SystemInfo'];

export function useSystemInfo() {
  return useQuery({
    queryKey: ['system', 'info'],
    queryFn: () => unwrap(api.GET('/api/v1/system/info')),
    staleTime: Infinity,
  });
}
